import { memo, ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { IClientOptionTeam } from '~/store/client/types';
import RadioGroup from '~/ui/components/inputs/RadioGroup';

interface IProps {
  teams: IClientOptionTeam[];
  fieldName: string;
  selectedTeamId?: number;
  onChangeCallback?: (value?: string) => void;
}

const TeamsField = ({
  teams,
  fieldName,
  selectedTeamId,
  onChangeCallback,
}: IProps): ReactElement => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const defaultValue =
    teams.find(t => t.id === selectedTeamId)?.id ?? teams.find(t => t.isPrimary)?.id ?? teams[0].id;

  useEffect(() => {
    setValue(fieldName, defaultValue);
  }, [defaultValue, fieldName, setValue]);

  return (
    <RadioGroup
      control={control}
      name={fieldName}
      errors={errors}
      cb={onChangeCallback}
      options={teams.map(team => ({
        label: team.name,
        value: team.id,
      }))}
      size="small"
    />
  );
};

export default memo(TeamsField);
